import skai_logo from "./../../../assets/images/HeaderLogo/blog_logo.svg";

export const AppLogo = (): JSX.Element => {
  return (
    <img
      src={skai_logo}
      height={"32px"}
      alt="logo"
      style={{
        objectFit: "contain",
          marginTop: 4
      }}
    />
  );
};